import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function Header({ onCartClick, showCart = false }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { getTotalItems } = useCart();
  
  const isActive = (path) => location.pathname === path;
  const cartCount = getTotalItems();
  
  // Show cart button on store and gamehub pages
  const showCartButton = showCart || location.pathname === '/store' || location.pathname === '/tutoring-hub';

  return (
    <nav className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/" className="flex items-center">
              <img src="/logo.webp" alt="Vencejo Academy Logo" className="h-12 w-auto mr-3" />
              <span className="text-2xl md:text-3xl font-display font-bold text-primary-600">Vencejo Academy</span>
            </Link>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex space-x-6 lg:space-x-8 items-center">
            <Link 
              to="/store" 
              className={`font-medium transition ${isActive('/store') ? 'text-primary-600' : 'text-gray-700 hover:text-primary-600'}`}
            >
              STORE
            </Link>
            <Link 
              to="/blog" 
              className={`font-medium transition ${isActive('/blog') ? 'text-primary-600' : 'text-gray-700 hover:text-primary-600'}`}
            >
              BLOG
            </Link>
            <Link 
              to="/contact" 
              className={`font-medium transition ${isActive('/contact') ? 'text-primary-600' : 'text-gray-700 hover:text-primary-600'}`}
            >
              CONTACT
            </Link>
            <Link 
              to="/tutoring-hub" 
              className={`font-medium transition ${isActive('/tutoring-hub') ? 'text-primary-600' : 'text-gray-700 hover:text-primary-600'}`}
            >
              TUTORING HUB
            </Link>
            <Link 
              to="/free-ebook" 
              className="font-medium text-red-600 hover:text-red-700 transition"
            >
              FREE EBOOK
            </Link>
            
            {/* Cart Button */}
            {showCartButton && onCartClick && (
              <button
                onClick={onCartClick}
                className="relative bg-primary-600 text-white px-4 py-2 rounded-lg hover:bg-primary-700 transition flex items-center font-medium"
              >
                Cart
                {cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </button>
            )}
          </div>
          
          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center gap-3">
            {/* Mobile Cart Button */}
            {showCartButton && onCartClick && (
              <button
                onClick={onCartClick}
                className="relative bg-primary-600 text-white px-3 py-2 rounded-lg hover:bg-primary-700 transition"
              >
                Cart
                {cartCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                    {cartCount}
                  </span>
                )}
              </button>
            )}
            
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 focus:outline-none"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
        </div>
        
        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-4 border-t border-gray-100">
            <Link 
              to="/store" 
              className={`block transition ${isActive('/store') ? 'text-primary-600 font-medium' : 'text-gray-700 hover:text-primary-600'}`}
              onClick={() => setIsMenuOpen(false)}
            >
              STORE
            </Link>
            <Link 
              to="/blog" 
              className={`block transition ${isActive('/blog') ? 'text-primary-600 font-medium' : 'text-gray-700 hover:text-primary-600'}`}
              onClick={() => setIsMenuOpen(false)}
            >
              BLOG
            </Link>
            <Link 
              to="/contact" 
              className={`block transition ${isActive('/contact') ? 'text-primary-600 font-medium' : 'text-gray-700 hover:text-primary-600'}`}
              onClick={() => setIsMenuOpen(false)}
            >
              CONTACT
            </Link>
            <Link 
              to="/tutoring-hub" 
              className={`block transition ${isActive('/tutoring-hub') ? 'text-primary-600 font-medium' : 'text-gray-700 hover:text-primary-600'}`}
              onClick={() => setIsMenuOpen(false)}
            >
              TUTORING HUB
            </Link>
            <Link 
              to="/free-ebook" 
              className="block font-medium text-red-600 hover:text-red-700 transition text-center"
              onClick={() => setIsMenuOpen(false)}
            >
              FREE EBOOK
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Header;

